export default "__VITE_ASSET__DSJPcRq$__"